import { AppFeature } from './types';

export const RESTRICTED_STATES_BY_FEATURE = {
  [AppFeature.LEASES]: new Set(['OR', 'WA']),
} satisfies Partial<Record<AppFeature, Set<string>>>;
